import type {
	RoutingGuideCarrier,
	RoutingGuideRule,
} from "~/shared/schemas/routing-guide-schema";
import { camelToTitlePreserveAcronyms } from "~/shared/utils/string-fns.ts";

export const rulesToString = (
	rules: RoutingGuideRule[] | RoutingGuideCarrier[],
) => {
	return rules
		.map((rule) => {
			const filedStrings: string[] = [];
			const ruleObject = rule as unknown as Record<string, unknown>;
			const fields = Object.keys(ruleObject).filter((key) =>
				key.startsWith("field"),
			);
			for (const fieldKey of fields) {
				const fieldValue = ruleObject[fieldKey] as {
					label: string;
					value: string | number;
				};
				if (fieldValue?.label && fieldValue?.value) {
					const label = camelToTitlePreserveAcronyms(fieldValue.label);
					filedStrings.push(`${label}: (${fieldValue.value})`);
				}
			}
			return filedStrings.join(", ");
		})
		.join(" | ");
};
